// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbsContainer":"Breadcrumbs_breadcrumbsContainer__15_At","breadcrumbs":"Breadcrumbs_breadcrumbs__3zOH5","route":"Breadcrumbs_route__1538Y"};